/** necessary relative import because they are imported in the storybook.d */
import type {
  CardDesign,
  Rarity,
  Sport,
} from '#src/__generated__/globalTypes.ts';
import type { LineupStyle } from '#src/components/lobby/ContenderLayout/types.ts';

import { local } from './index.ts';

export enum SportSelectType {
  ALL_SPORTS = 'allSport',
  FOOTBALL = 'football',
  BASEBALL = 'baseball',
  NBA = 'nba',
}

export type LocalStorageEntries = {
  test: any; // any on purpose for testing any values
  showOnlyGamesWithLinedUpPlayers: any;
  sortingOrderSchedule: any;
  includeCommonsSchedule: any;
  mlbGameViewStats: 'fantasy' | 'actual';
  savedHistory: any;
  trackingConsent: boolean;
  mlbMonthlyChaseLastPreferredScarcity: any;
  useRedDotNotification: any;
  useBaseballRedDotNotification: any;
  useNbaRedDotNotification: any;
  sportLineupStyle: Record<Sport, LineupStyle>;
  mlbOffseasonCountdownReminder: any;
  sport: Sport | undefined;
  lastVisitedEventType: any;
  navigationSidebarCollapsed: boolean;
  myBidsBannerIgnoredBids: string[];
  expandLiveEvent: boolean;
  DEVICE_FINGERPRINT: string;
  randomSessionId: string;
  selectedSport: 'football' | 'baseball' | 'nba';
  selectedDesign: CardDesign;
  cardEditionName: string;
  'gql-debug': boolean;
  'MySorare.selectedSport': SportSelectType;
  arenaRarityFilter: Rarity;
  REFERRER: string;
  IMPACT_CLICKID: string;
  GOOGLE_CLICKID: string;
  FACEBOOK_CLICKID: string;
  TWITTER_CLICKID: string;
  TIKTOK_CLICKID: string;
  SNAPCHAT_CLICKID: string;
  REDDIT_CLICKID: string;
  INVITATION_TOKEN: string;
  UTM_SOURCE: string;
  UTM_MEDIUM: string;
  UTM_CAMPAIGN: string | number | undefined;
  UTM_TERM: string;
  UTM_CONTENT: string;
  CUSTOM_PROFILE_ID: string;
  TRAFFIC_CATEGORY: string;
  PARTNER: string;
  USER: string;
};
export const localStorage = {
  getItem: <K extends keyof LocalStorageEntries>(value: K) =>
    local.getItem(value) as LocalStorageEntries[K],
  getStringItem: <K extends keyof LocalStorageEntries>(value: K) =>
    local.getItem(value)?.toString() as LocalStorageEntries[K],
  setItem: <K extends keyof LocalStorageEntries>(
    key: K,
    value: LocalStorageEntries[K] | null
  ) => local.setItem(key, value),
  removeItem: <K extends keyof LocalStorageEntries>(key: K) =>
    local.removeItem(key),
  key: (index: number) => local.key(index),
  length: local.length,
  clear: local.clear,
};
